import React, { useEffect, useState } from 'react';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import ExperienceSection from '@/components/ExperienceSection';
import ProjectsSection from '@/components/ProjectsSection';
import SkillsSection from '@/components/SkillsSection';
import ArticlesSection from '@/components/ArticlesSection';
import ContactSection from '@/components/ContactSection';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { api } from '@/services/api';
import { trackPageView } from '@/services/analytics';
import '@/styles/HomePage.css';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [projects, setProjects] = useState([]);
  const [articles, setArticles] = useState([]);
  const [experience, setExperience] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Track page view
    trackPageView('home');
    
    // Load data from backend
    loadData();

    const handleScroll = () => {
      const sections = ['home', 'about', 'experience', 'projects', 'skills', 'articles', 'contact'];
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    try {
      const [projectsData, articlesData, experienceData, settingsData] = await Promise.all([
        api.getProjects(),
        api.getArticles(),
        api.getExperience(),
        api.getSettings()
      ]);
      setProjects(projectsData);
      setArticles(articlesData);
      setExperience(experienceData);
      setSettings(settingsData);
    } catch (error) {
      console.error('Failed to load data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="homepage">
      <Navbar activeSection={activeSection} />
      <HeroSection settings={settings} loading={loading} />
      <AboutSection settings={settings} loading={loading} />
      <ExperienceSection experience={experience} loading={loading} />
      <ProjectsSection projects={projects} loading={loading} />
      <SkillsSection />
      <ArticlesSection articles={articles} loading={loading} />
      <ContactSection settings={settings} />
      <Footer settings={settings} />
    </div>
  );
};

export default HomePage;